"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritTypeCorporationTrads = void 0;
exports.ESubDejaSouscritTypeCorporationTrads = {
    autre: "Autre",
    logement: "Logement (borloo Robien, Scellier.....)",
    murs_commerce: "Murs de commerce",
};
